import React from 'react';
// Router
import { HashRouter as Router } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import App from './App';
import { useGetSetting } from 'hooks/SettingHooks';
import { STORE_URL } from 'utils';

const AppContainer = () => {
  /* ===== Initial ===== */
  const initial = {
    title: '제이엠커피 | jmcoffeemall',
    description:
      '스페셜티 원두 구매부터 커피용품 쇼핑까지 – JM커피 공식 온라인몰 커피 정기배송, 원두, 드립백, 콜드브루, 커피머신 등 판매',
    meta_tag: [],
    image_url: null,
    favicon_url: null,
  };

  /* ===== Data ===== */
  const { data: seo } = useGetSetting(1, null, {
    initialData: initial,
    select: (res) => {
      const { status, data } = res;

      if (status !== 200) return initial;

      return data.seo_setting;
    },
  });

  /* ===== State ===== */
  /* ===== Functions ===== */

  /* ===== Hooks ===== */

  /* ===== Render ===== */
  return (
    <Router>
      <Helmet>
        {seo.meta_tag.length
          ? seo.meta_tag.map((meta, index) => (
              <meta key={`meta-${index}`} {...meta} />
            ))
          : null}

        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        {seo.image_url ? (
          <meta property="og:image" content={`${STORE_URL}/${seo.image_url}`} />
        ) : null}
        {seo.favicon_url ? (
          <link rel="icon" href={`${STORE_URL}/${seo.favicon_url}`} />
        ) : null}
      </Helmet>
      <App />
    </Router>
  );
};

export default AppContainer;
